import './wp-by-order-info.scss';

import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';

import WpBaseComponent from './../wp-base-component';
import { ActionResult, IHelpDeskService, HelpDeskSymbols, INotificationService, NotificationSymbols, AppSettings } from 'web-platform-help-desk-core-frontend-ui';
import { Order } from 'web-platform-help-desk-core-frontend-ui/src/HelpDesk/order-info';
import { ModuleType } from 'web-platform-help-desk-core-frontend-ui/src/Global/module-type';

@Component({
    template: require("./wp-by-order-info.html")
})

export default class WpByOrderInfo extends mixins(WpBaseComponent, Vue) {
    protected _service!: IHelpDeskService;
    protected _notificationService!: INotificationService;

    Email: string = "";
    PhoneNumber: string = "+7";
    SearchMethod: number = 0;
    Code: string = "";
    HintVisible: boolean = false;

    Title: string = "Получение заказа по реквизитам";
    DisabledUI: boolean = false;
    FormIsValid: boolean = false;
    SearchBySignActive = false;
    SearchMethods: Array<any> = [
        { Title: "По номеру заказа", Value: 0 },
        { Title: "По номеру платежа", Value: 1 },
    ];

    get PhoneRules() {
        return [
            (v: string) => (/^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){11,14}(\s*)?$/.test(v))
        ];
    };
    get PhoneEnabled() {
        return AppSettings.PhoneFieldEnabled;
    }

    RemoveCodeWhiteSpace() {
        this.$nextTick(() => {
            this.Code = this.Code.replace(/ /g, "");
        });
    };

    RemoveEmailWhiteSpace() {
        this.$nextTick(() => {
            this.Email = this.Email.replace(/ /g, "");
        });
    };

    Rules: Object = {
        Email: [
            (val: any) => (val || '').length > 0 || "Обязательное поле",
            (v: string) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Неверный формат E-mail",
        ],
        Name: [
            (val: any) => (val || '').length > 0 || "Обязательное поле",
        ],
        Phone: [
            (val: any) => (val || '').length == 16 || "Неверный формат номера телефона",
        ],
        Code: [
            (val: any) => (val || '').length > 0 || "Обязательное поле",
        ],
    };

    ScreenShot1: string = require("@/assets/screenshot001.png");
    ScreenShot2: string = require("@/assets/screenshot002.png");

    DialogSearchResult: boolean = false;
    SearchResult: Order | null = null;

    created() {
        this._service = this.GlobalService.Get<IHelpDeskService>(HelpDeskSymbols.HelpDeskService);
        this._notificationService = this.GlobalService.Get<INotificationService>(NotificationSymbols.NotificationService);
    };

    async mounted() {
        this.DisabledUI = true;
        this.SearchBySignActive = true;

        if (window.location.href.includes('sign') && window.location.href.includes('orderId') && window.location.href.includes('email')) {
            let params = window.location.href.split('?')[1];
            let sign = params.split('&')[0].replace('sign=', '');
            let orderId = params.split('&')[1].replace('orderId=', '');

            let email = params.split('&')[2].replace('email=', '');
            if (email.includes('%40')) {
                email = email.replace('%40', '@');
            };

            if (!window.location.href.includes('phone') && this.PhoneEnabled) {
                return;
            }

            let phone = '';

            if (window.location.href.includes('phone')) {
                phone = params.split('&')[3].replace('phone=', '');
                if (phone.includes('%20')) {
                    phone = phone.replace('%20', '+');
                };

                if (phone.startsWith('8')) {
                    phone = phone.replace('8', '+7');
                };
            }

            this._notificationService.Success("Уведомление", "Запрошена информация по Вашему заказу! Пожалуйста, подождите...");

            const result = await this._service.FindByLinkParametersAsync(sign, parseInt(orderId), email, phone);

            if (result.Success) {
                this.SearchResult = result.Data!;
                this.DialogSearchResult = true;
            } else {
                this._notificationService.Error("Ошибка", result.ErrorMessage || "Не удалось найти информацию о заказе");
            };
        };

        this.DisabledUI = false;
        this.SearchBySignActive = false;
    }

    PhoneFocus(value: string): void {
        console.log(value);
        this.PhoneNumber = "+7";

        if (value.length < 2) {
            this.$nextTick(() => {
                this.PhoneNumber = "+7" + value;
            });
        };

        if (value.startsWith('7')) {
            value = value.replace('7', '');
            console.log(value);
            this.PhoneNumber += value;
        };

        if (value.startsWith('8')) {
            value = value.replace('8', '');
            console.log(value);
            this.PhoneNumber += value;
        };
    };

    protected async GetDataByOrderInfo(): Promise<ActionResult> {
        this.DisabledUI = true;
        this.Email = this.Email.trimStart().trimEnd()

        if (this.SearchMethod == 0) {
            if (this.Code.includes('_')) {
                this._notificationService.Error("Ошибка", "Укажите корректный номер заказа");
            } else {
                let result = await this._service.FindByCodeAsync(parseInt(this.Code), this.Email, this.PhoneEnabled ? this.NormalizedPhone() : "");
                if (result.Success && result.Data != null) {
                    this.SearchResult = result.Data;
                    this.DialogSearchResult = true;
                } else {
                    this._notificationService.Error("Ошибка", result.ErrorMessage || "Не удалось найти информацию о заказе");
                };
            }
        } else {
            if (this.Code.includes('_')) {
                let result = await this._service.FindByPaymentCodeAsync(this.Code, this.Email, this.NormalizedPhone());
                if (result.Success && result.Data != null) {
                    this.SearchResult = result.Data;
                    this.DialogSearchResult = true;
                    //let stringDate = result.Data!.RegistredDate.toString();
                    //let shordDate = stringDate.split(':')[0];
                    //let date = shordDate.split('-')[2].replace('T15', '') + shordDate.split('-')[1] + shordDate.split('-')[0];

                    //if (result.Data?.UserName !== this.Email || result.Data?.UserPhone !== this.NormalizedPhone() || date !== this.Code.split('_')[0]) {
                    //    this._notificationService.Error("Ошибка", "Не удалось найти информацию о заказе");
                    //} else {
                    //    this.SearchResult = result.Data;
                    //    this.DialogSearchResult = true;
                    //};
                } else {
                    this._notificationService.Error("Ошибка", result.ErrorMessage || "Не удалось найти информацию о заказе");
                };
            } else {
                this._notificationService.Error("Ошибка", "Укажите корректный номер платежа");
            };
        };

        this.DisabledUI = false;
        return ActionResult.Success();
    };

    NormalizedPhone(): string {
        let phone = this.PhoneNumber.replace('(', '').replace(')', '').replace('-', '').replace('-', '');
        return phone;
    };
};

